import { useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useAppSelector, useAppDispatch } from "@app/hooks";
import { termRulesHandlersDataSelector } from "@terms/store/selectors";
import { resetRules } from "@terms/store/ducks";

export const useTermsRulesHandling = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();

  const { rules, outstandingTermsData, activeTermData, dialogOpen } = useAppSelector(termRulesHandlersDataSelector);

  const runImmediateRulesIfPresent = useCallback(
    (accepted: boolean) => {
      rules.afterEach
        .filter(({ condition }) => condition({ ...activeTermData!, accepted }, outstandingTermsData!))
        .forEach(({ action }) => action({ history, dispatch }));
    },
    [activeTermData, outstandingTermsData, rules.afterEach, history, dispatch]
  );

  const runFinalRulesIfPresent = useCallback(() => {
    rules.afterAll
      .filter(({ condition }) => condition(outstandingTermsData!))
      .forEach(({ action }) =>
        action({
          history,
          dispatch,
        })
      );
  }, [rules.afterAll, outstandingTermsData, history, dispatch]);

  useEffect(() => {
    if (!dialogOpen && rules.afterAll.length) {
      runFinalRulesIfPresent();

      dispatch(resetRules());
    }
  }, [dialogOpen, runFinalRulesIfPresent, rules.afterAll, dispatch]);

  return {
    runImmediateRulesIfPresent,
    runFinalRulesIfPresent,
  };
};
